import React from 'react'
import Config from '../../config/days'

if(!Array.prototype.find){Object.defineProperty(Array.prototype,"find",{value:function(predicate){if(this==null){throw new TypeError('Array.prototype.find called on null or undefined')}
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function')}
var list=Object(this);var length=list.length>>>0;var thisArg=arguments[1];var value;for(var i=0;i<length;i++){value=list[i];if(predicate.call(thisArg,value,i,list)){return value}}
return undefined}})}
let zeropad = (n) => (n.toString().length <2 ? "0"+ n : n)

class Calendar extends React.Component{
    constructor(props){
        super(props);
        this.date = new Date();
        this.isRepublican = !0;
        this.isCustomDate = !1;
        if(this.props.years !== undefined && this.props.month !== undefined && this.props.day !== undefined){
            this.setDate(this.props.years, this.props.month-1, this.props.day);
        }

        this.state = {
            day : this.isRepublican ? this.getDay() : this.date.getDate(),
            month: this.isRepublican ? this.getMonth() : Config.gregorianMonth[this.date.getMonth()],
            year: this.isRepublican ? this.getYear() : this.date.getFullYear(),
            stringDay: this.isRepublican ? this.getStringDay(this.getDay()) : Config.gregorianDay[this.date.getDay() -1],
            nameDay: this.getNameDay()
        }

        this.transformDate = this.transformDate.bind(this);
    }
    componentDidMount(){
        this.timer = setInterval(() => this.tick(), 5000);
    }
    componentWillUnmount(){
        clearInterval(this.timer);
    }
    tick(){
        this.date = (this.isCustomDate? this.date : new Date());
        let day = this.isRepublican ? this.getDay() : this.date.getDate();
        let month = this.isRepublican ? this.getMonth()  : Config.gregorianMonth[this.date.getMonth()];
        let year = this.isRepublican ? this.getYear() : this.date.getFullYear();
        let stringDay = this.isRepublican ? this.getStringDay(this.getDay()) : Config.gregorianDay[this.date.getDay() -1];
        let nameDay= this.getNameDay()

        this.setState({day, month, year,stringDay, nameDay});
    }
    getDay(){
        let startDay = Config.republicanMonth.find(x => x.name === this.getMonth()).startDay;
        let day = +(this.date.getDate()) - startDay + this.getDayIndex();
        day = day <= 0 ? this.date.getDate() + this.getGapDay() + this.getDayIndex() : day;
        return day;
    }
    getNameDay(){
        let indexDay = zeropad(this.getDay());
        let indexMonth = Config.republicanMonth.indexOf(Config.republicanMonth.find(x => x.name === this.getMonth()));
        indexMonth = zeropad(indexMonth +1);
        let index = indexDay+""+indexMonth;
        return Config.dayName.find(x => x.id === index) !== undefined ? Config.dayName.find(x => x.id === index).name : "";
    }
    getStringDay(day){
        let specialDay = this.checkSpecial(day);
        if(specialDay !== undefined && specialDay.length > 4){
            return specialDay;
        }
        day--;
        while(Config.republicanDays[day] === undefined){
            day -= 10;
        }
        return Config.republicanDays[day++];
    }
    checkSpecial(day){
        if(this.date.getMonth()+1 === 9){
            day = this.isSextile() ? day--: day;
            let indiceDay = day-1;
            return Config.complementaryDays[indiceDay];
        }
        return +1;
    }
    getMonth(){
        let month = this.date.getMonth() + 1;
        let tmpIndex = month > 8 ? month - 8 : month + 4;
        let indexMonth = (tmpIndex - this.getMonthIndex(tmpIndex)) - 1;
        let september = indexMonth < 0 ;
        indexMonth = indexMonth < 0 ? 11 : indexMonth;
        if((this.date.getDate() > 16 || (this.date.getDate() > 15 && this.isSextile())) && this.date.getDate() < 22 && september) indexMonth++;
        return Config.republicanMonth[indexMonth].name;
    }
    getYear()
    {
        return this.date.getFullYear() - this.getYearIndex();
    }
    getDayIndex(){
        let dayIndex = 0;
        if(this.isSextile() && !this.isNewCentury()) dayIndex++;
        if(this.date.getFullYear()>= 1992) dayIndex++;
        return dayIndex;
    }
    getGapDay(){
        let days =  new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDate();
        return days - Config.republicanMonth.find(x => x.name === this.getMonth()).startDay;
    }
    getMonthIndex(tmpIndex){
        let monthObject = Config.republicanMonth.find(x => x.startMonth === tmpIndex)
        return this.date.getDate() > monthObject.startDay ? 0 : 1;
    }
    getYearIndex(){
        var month = +(parseInt(this.date.getMonth(), 10)+1);
        return month < 9 ? 1792 : (+this.date.getDate()) < 22 && month === 9 ? 1792 : 1791;
    }
    isSextile(){
        return new Date(this.getYear(), 2, 0).getDate() > 28
    }
    isNewCentury(){
        return !+(this.date.getFullYear().toString().substring(2,4).indexOf("92")) && this.date.getFullYear() > 1792;
    }
    transformDate(){
        this.isRepublican = !this.isRepublican;
        this.tick();
    }
    setDate(year, month, day){
        this.date = new Date(year, month, day);
        this.isCustomDate = !0;
    }
    render(){
        return <div className="calendar" onClick={this.transformDate}>{this.state.stringDay} {this.state.day} {this.state.month} {this.state.year}<br/>{this.state.nameDay}</div>
    }
}

export default Calendar


// WEBPACK FOOTER //
// ./src/component/calendar/calendar.js